import React, { Fragment, useState } from 'react'
import Header from '../Header';
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { createCategory } from '../../../actions/category';
import { logout } from '../../../actions/auth';

import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

const CreateCategory = ({ createCategory }) => {


    const [formData, setFormData] = useState({
        categoryName: '',
        description: '',
    });
    const { categoryName, description } = formData;
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = e => {
        e.preventDefault();
        createCategory({ categoryName, description });
        setFormData({ categoryName: '', description: '' });
    };

    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage'>
                    <Header heading="Create Category" />
                    <div className='createForm'>
                        <form className="form mt-5" onSubmit={e => onSubmit(e)}>
                            <div className="card">
                                <h5 className="card-header">Basic Info</h5>
                                <div className="card-body p-5">
                                    <div className='mb-5'>
                                        <label htmlFor='business_name' className="form-label">Service category name</label>
                                        <input type="text" className='form-control form-control-lg' name="categoryName" id='categoryName' value={categoryName} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                    <div className="mb-5">
                                        <label htmlFor="businessEmail" className="form-label">Service category description</label>
                                        <textarea className='form-control form-control-lg' name="description" id='description' value={description} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                </div>
                            </div>
                            <div className='text-center pt-4 d-flex justify-content-end'>
                                <Link to='/catalogue/create-service' className="btn btn-custom-ouline  me-4"  >Cancel</Link>
                                <input type="submit" className="btn btn-custom" value="Save" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );

}

CreateCategory.propTypes = {
    logout: PropTypes.func.isRequired,
    createCategory: PropTypes.func.isRequired,
}
const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps, { createCategory, logout })(CreateCategory);
